import React from 'react';

import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

export interface SecaoProps {
    idSecao: number;
    cdSecao: number;
    dsSecao: string;
}

type SecaoAutoCompleteProps = Pick<
    CissAutoCompleteProps,
    'requestOptions' | 'label' | 'value' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange' | 'size' | 'optionStringTemplate'
>;

export function SecaoAutoComplete({
    size,
    value,
    error,
    label = 'Seção',
    multiple = false,
    sx,
    onChange,
    requestOptions = {
        url: '/gestao/secao',
        sort: [{ property: 'dsSecao', direction: 'ASC' }],
        columns: 'idSecao,dsSecao,cdSecao',
        limit: 100,
    },
    optionStringTemplate = '{dsSecao}',
}: SecaoAutoCompleteProps) {
    return (
        <CissAutoComplete
            size={size}
            label={label}
            value={value}
            multiple={multiple}
            error={error}
            selectedStringTemplate="{dsSecao}"
            optionStringTemplate={optionStringTemplate}
            requestOptions={requestOptions}
            isOptionEqualToValue={(option: SecaoProps, value: SecaoProps) => option.idSecao === value.idSecao}
            onChange={onChange}
            sx={sx}
        />
    );
}
